import { StdResponse, bimAxios } from "@/config/axios"

export function findRoofSlabSectionsByprojectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/roof-slab-sections`, {
        params: {
            ...params,
        }
    })
}

export function addRoofSlabSection(projectUuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/roof-slab-sections`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteRoofSlabSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/roof-slab-sections/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function updateRoofSlabSection(uuid: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/roof-slab-sections/${uuid}`, data, {
        params: {
            ...params,
        }
    })
}

export function findRoofSlabSectionByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/roof-slab-sections/${uuid}`, {
        params: {
            ...params,
        }
    })
}
